import React, { Component } from 'react'
import CollapseInfo from './CollapseInfo.jsx'

export default class InstructionsTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leftOptionRadarTiming: true,
            leftOptionStanceSprint: true,

        }

        this.handleClick = this.handleClick.bind(this);
        this.getStyle = this.getStyle.bind(this);
        this.renderTextInRadarTimingList   = this.renderTextInRadarTimingList.bind(this)
        this.renderTextInStartOrSprintList = this.renderTextInStartOrSprintList.bind(this)
        
    }

    // Get style based on what the togglePullPush is set to
    getStyle(styleName,leftStateName) {
        const theseStates = this.state;
        const leftOption = theseStates[leftStateName];

        if (leftOption && styleName === "leftOption") {
            return ("textOptionalLeftUnClicked")
        }
        if (!leftOption && styleName === "leftOption") {
            return ("textOptionalLeft")
        }

        if (!leftOption && styleName === "rightOption") {
            return ("textOptionalRightUnClicked")
        }
        else if (leftOption && styleName === "rightOption") {
            return ("textOptionalRight")
        }

    }

    handleClick(leftStateName, event) {
        const { name } = event.target;
        const theseStates = this.state;
        const leftOption = theseStates[leftStateName];

        if (!leftOption && name === "leftOption") {
            this.setState({ [leftStateName] : !leftOption })
        }

        if (leftOption && name === "rightOption") {
            this.setState({ [leftStateName]: !leftOption })
        }

    }

    renderTextInRadarTimingList(leftStateName) {
        const theseStates = this.state;
        const leftOption = theseStates[leftStateName];

        if (leftOption) {
            return (
                <div className="listContainer">
                    <ul>
                        <li>{'Place the radar or laser device 5m behind the athlete pointed at the lower back.'}</li>
                        <li>{'Record the peak maximum velocity (Vmax) attained during the sprint in either kmph. / mph or m/s.'}</li>
                    </ul>
                </div>
                )
        }
        else {
            return (
                <div className="listContainer">
                    <ul>
                        <li>{'Set up timing gates at 10 m intervals throughout the sprint. 5m intervals can be used during heavy resisted trials for more accuracy.'}</li>
                        <li>{'Perform the sprint and note the fastest 5/10 m split time to calculate average peak speed ( 5/10 m / split time ).'}</li>
                   </ul>

                </div>

                )
        }

    }

    renderTextInStartOrSprintList(leftStateName) {
        const theseStates = this.state;
        const leftOption = theseStates[leftStateName];

        if (leftOption) {
            return (
                <div className="listContainer">
                    <ul>
                        <li>{'Position the athlete in a chosen starting stance to best mimic the demands of the chosen sport.'}</li>
                        <li>{'Two, three, four point or block start stance can be used in sled pulling whereas a two-point standing start should be used for sled pushing.'}</li>
                    </ul>
                </div>
            )
        }
        else {
            return (
                <div className="listContainer">
                    <ul>
                        <li>{'Perform 1 unresisted and a minimum of two resisted sprints, three are recommended.'}</li>
                        <li>{'Record the load and maximum velocity for each sprint and input in step 3.'}
                            <li>{'Recommended %BM load are preset as default guidelines but can be adjusted to coach/athlete preference in step 3.'}</li>
                            <li>{'Max velocity achieved in kmph / mph or m/s must be entered for each trial'}</li>
                        </li>
                        <li>{'3 minutes rest Is recommended between each sprint.'}</li>
                    </ul>                    
                </div>

            )
        }

    }

    render() {
        return (
            <div>
                <CollapseInfo classCollapseInfoContainer="containerInstructions" classCollapseInfoContent="contentInstructions" classCollapseHeader="instructionsMoreInfo" titleFalse="Hide setup & instructions" titleTrue="See setup & instructions" Type="showHide">               
                    <div className="instructionsMoreInfoExtra">
                        <h3 className="heading3Instr">{'Timing device options for collecting maximum velocity'}</h3>
                <div className="panel">
                    <div className="textOptionalContainer">
                        <button name={"leftOption"} className={this.getStyle("leftOption", "leftOptionRadarTiming")} onClick={(evt) => this.handleClick("leftOptionRadarTiming", evt)}>Radar/Laser</button>
                        <button name={"rightOption"} className={this.getStyle("rightOption", "leftOptionRadarTiming")} onClick={(evt) => this.handleClick("leftOptionRadarTiming", evt)}>Timing Gates</button>                        
                    </div>
                    {this.renderTextInRadarTimingList("leftOptionRadarTiming")}
                </div>
                        <h3 className="heading3Instr">{'Performing unresisted and resisted sprint trials'}</h3>
                <div className="panel">
                    <div className="textOptionalContainer">
                        <button name={"leftOption"} className={this.getStyle("leftOption", "leftOptionStanceSprint")} onClick={(evt) => this.handleClick("leftOptionStanceSprint", evt)}>Starting Stance</button>
                        <button name={"rightOption"} className={this.getStyle("rightOption", "leftOptionStanceSprint")} onClick={(evt) => this.handleClick("leftOptionStanceSprint", evt)}>Sprinting Trials</button>
                    </div>
                    {this.renderTextInStartOrSprintList("leftOptionStanceSprint")}
                        </div>
                    </div>
                </CollapseInfo>
            </div>
        );
    }
}